import { DeviceProfile } from "./DeviceProfile";
import { LayoutMode } from "./LayoutMode";

export interface UILayoutProfile {

  mode: LayoutMode;

  phoneUI: boolean;

  scale: number;

  chat: {
    width: number;
    bottom: number;
    radius: number;
    maxHeight: number;
    padding: number;
  };

  dock: {
    height: number;
    bottom: number;
  };

  buttons: {
    size: number;
    gap: number;
  };

  avatar: {
    scale: number;
    offsetY: number;
  };

  clock: {
    left: number;
    bottom: number;
  };

  disclosure: {
    bottom: number;
  };

  fontScale: number;
}

export function createUILayout(
  device: DeviceProfile,
  mode: LayoutMode
): UILayoutProfile {

  switch (mode) {

    case "compact":

      return {

        mode,

        phoneUI: true,

        scale: 1,

        chat: {
          width: 520,
          bottom: 170,
          radius: 22,
          maxHeight: 360,
          padding: 18,
        },

        dock: {
          height: 126,
          bottom: 0,
        },

        buttons: {
          size: 48,
          gap: 12,
        },

        avatar: {
          scale: 1,
          offsetY: 0,
        },

        clock: {
          left: 20,
          bottom: 20,
        },

        disclosure: {
          bottom: 8,
        },

        fontScale: 1,
      };

    case "comfortable":

      return {

        mode,

        phoneUI: false,

        scale: 1,

        chat: {
          width: 540,
          bottom: 170,
          radius: 22,
          maxHeight: 420,
          padding: 20,
        },

        dock: {
          height: 126,
          bottom: 0,
        },

        buttons: {
          size: 48,
          gap: 12,
        },

        avatar: {
          scale: 1,
          offsetY: 0,
        },

        clock: {
          left: 20,
          bottom: 20,
        },

        disclosure: {
          bottom: 8,
        },

        fontScale: 1,
      };

    default:

      return {

        mode,

        phoneUI: false,

        scale: 1,

        chat: {
          width: 540,
          bottom: 170,
          radius: 22,
          maxHeight: 520,
          padding: 22,
        },

        dock: {
          height: 126,
          bottom: 0,
        },

        buttons: {
          size: 48,
          gap: 12,
        },

        avatar: {
          scale: 1,
          offsetY: 0,
        },

        clock: {
          left: 20,
          bottom: 20,
        },

        disclosure: {
          bottom: 8,
        },

        fontScale: 1,
      };
  }
}
